export class SheetController {
  open: (options?: { [key: string]: any }) => void | Promise<void> = () => {};
  close: (animateOut?: boolean) => Promise<void> = () => Promise.resolve();
  setWidth: (width?: string) => void = () => {};
  setMaxWidth: (maxWidth?: string) => void = () => {};
  resetSize: () => void = () => {};
}
